import type { AgentRecord } from "@/types/api/agent"
import type { SimulationMetadata } from "@/types/backend-contracts"

/**
 * The agent config a launch of this agent submits, so a rerun and a fresh launch
 * of the same agent send the same fields.
 */
export function buildAgentSimulationMetadata(
  agent: AgentRecord,
): SimulationMetadata {
  const metadataPhoneNumber = agent.metadata?.phone_number

  return {
    ...agent.metadata,
    phone_number:
      agent.phone_number ||
      (typeof metadataPhoneNumber === "string" ? metadataPhoneNumber : ""),
  }
}
